import {formatInnDisplay} from './inn';

export type MyTaxNameMismatchInfo = {
	inn: string;
	fullName: string;
};

export const MY_TAX_NAME_MISMATCH_TITLE = 'Не совпадает ФИО';

export const MY_TAX_NAME_MISMATCH_CONFIRM_LABEL = 'Окей, понятно';

export const buildMyTaxNameMismatchDescription = ({inn, fullName}: MyTaxNameMismatchInfo): string => {
	const formattedInn = formatInnDisplay(inn);

	return `По данным ФНС, ИНН ${formattedInn} принадлежит самозанятому с именем ${fullName}.\n\nМы обновили ваши ФИО в приложении. Если это неверные данные, обратитесь в ближайшую налоговую`;
};
